import styled, { css } from 'styled-components'
import { Hover, UnstyledLinkInline } from '../../styles/mixins'
import LinkRender from './LinkRender'

type Props = {
  className?: string,
  [key: string]: any
}

const LinkUnderline: React.FC<Props> = ({
  className,
  ...props
}: Props) => {
  return (
    <Wrapper className={className + ' link-inline'} >
      <Link {...props} />
    </Wrapper>
  )
}



const Wrapper = styled.span`
  ${UnstyledLinkInline};
  --LinkUnderline-color: var(--color-charcoal600);
  --LinkUnderline-hover-color: var(--color-charcoal400);
`

const Link = styled(LinkRender)<{$disabled: boolean | undefined}>`
  display: inline-flex;
  color: var(--LinkUnderline-color);
  text-decoration: underline;

  ${Hover} {
  color: var(--LinkUnderline-hover-color);
  }
  
  ${props => props.$disabled && css`
    color: var(--color-charcoal300);
    pointer-events: none;
  `}
`

export default LinkUnderline
